import { Link, Outlet } from "react-router";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";

import SignOut from "../../features/auth/signOut";

import adminLogo from "../../assets/logos/logo-admin.png";
import { LangSwitcher } from "../lang-switcher";

function SuperAdminLayout() {
	return (
		<Box sx={{ display: "flex" }}>
			<CssBaseline />
			<AppBar
				position="fixed"
				sx={{
					width: `100%`,
					background: "#284B7A",
					boxShadow: "none",
				}}
			>
				<Toolbar
					sx={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
					}}
					variant="dense"
				>
					<Link to="/admin">
						<Box sx={{ display: "flex", alignItems: "center" }}>
							<img src={adminLogo} alt="CargoSeller" width="190" />
						</Box>
					</Link>
					<Box
						sx={{
							display: "flex",
							justifyContent: "end",
							alignItems: "center",
						}}
					>
						<Box sx={{ mr: "20px" }}>
							<LangSwitcher />
						</Box>
						<SignOut />
					</Box>
				</Toolbar>
			</AppBar>
			<Box component="main" sx={{ flexGrow: 1, bgcolor: "background.default" }}>
				<Toolbar variant="dense" />
				<Box sx={{ p: 6 }}>
					<Outlet />
				</Box>
			</Box>
		</Box>
	);
}
export default SuperAdminLayout;
